



import { HostBinding,Renderer2,HostListener,AfterViewChecked,ChangeDetectorRef,ElementRef,ViewChild,ViewChildren,QueryList,Component, OnInit, OnChanges, OnDestroy ,SimpleChanges, AfterViewInit,ViewEncapsulation} from '@angular/core';

import   html2canvas from 'html2canvas';

import {DomSanitizer} from '@angular/platform-browser';


declare var $ : any;

import {SectionComponent} from '../../sections/section.component';

import {BoxComponent} from '../../boxes/boxes.component';

import {MessageService} from '../../message.service';

import {SearchPanelComponent} from '../../panel/searchPanel.component';

import { ToastrService } from 'ngx-toastr';

import {NewsletterService} from '../../services/newsletter.service';

import{ArticleService} from '../../services/article.service';

import{CalendarService} from '../../services/calender.service';

import {Subscription} from 'rxjs';

import { Router,ActivatedRoute } from '@angular/router';

import {AppSettings} from '../../settings';

import {BaseComponent} from '../base/base.component';

import {HomeService} from '../../services/home.service';

import {TemplateService} from '../../services/template.service';

import {NgbdModalBasic} from '../../dashboard/modals/calender_invite_modal/invite_modal.component';

import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';





@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css'],
  encapsulation:ViewEncapsulation.None,
  host: {
    '(document:click)': 'onClick($event)',
  }
})
export class TemplateComponent  extends BaseComponent implements OnInit,OnChanges,OnDestroy,AfterViewInit,AfterViewChecked{

  @HostBinding('style.width') public width: string = '100%';

  dropdownSettings = {};

  selectedGroup:any=[];

  // hDes:any= '<div class="top-black-hld"><h1 style="margin:0;"><img class="black-hld-logo" style="margin-right:30px;vertical-align:middle;" src="'+AppSettings.CMS_ENDPOINT+'/assets/images/logo-white.png">After Sales Newsletter</h1></div>';
  hDes:any= '<div class="black-bg"><h1 class="template-header"><img class="black-hld-logo header-image"  src="'+AppSettings.API_ENDPOINT+'images/logo.png">&nbsp;&nbsp;&nbsp;After Sales Newsletter</h1></div>';
  footerDescription:any='<p>To view this Newsletter Correctly please ensure you have a Mitsubishi Motors official MMC OFFICE fonts installed on your PC</p>';

  headerDescription:any='';

  templateGroupList:any =[


  ];


  title = 'emailtemplates';

  sendArray:any=[];

  modified_newsletter:any=[];


  showMsg:boolean =true;

  newsSubscription:Subscription;

  bannerImage:any ;

  snapImage:any;

  srchTxt:string;

  showPanelIndex:number = 0;

  msg:any;

  token:string='';

  toastr:any;

  homeservice:any;

  _router:any;

  newsletterid:number=0;

  templateid:number=0;


 finalJson:any={

    templateName:'',
    image:'',
    sections:{
      bannerImage:'',
      sectionData:'',
      menuSetting:''
    }

   };

   groupError:string = ''

   template_name:string='';




  showHide($event:any){


    console.log($event);

    this.showPanelIndex = $event.index;

    this.dropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'value',
      closeDropDownOnSelection:true
    };
  }
  url:any=AppSettings.API_ENDPOINT

  @HostListener('window:scroll', ['$event'])

    onWindowScroll($event) {


         if(this.navSectionIndex!=undefined && this.navSectionIndex!=-1){

          let nextIndex =this.navSectionIndex;


          if($event.target['scrollingElement'].scrollTop > $('#sect_'+nextIndex).offset().top){


            this.navSectionStyle={

              display:'none'
           }

            this.navSectionIndex =-1;

          }



         }


    }


  section_item:number =1;

  navSettingIndex:number;
  navSettingStyle:any;
  navSectionIndex:number;
  navSectionStyle:any;
  navSettingHeader:string;
  removeSettingDialog:any;
  sectionRemoveId:number;

  currentSectionIndex:number;

  templateName:any;
  templateNumber:any;
  publish:any;
  checkedval:boolean=false;




  sections:Array<any>=[
    {"layout":3,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{},"cardCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{},"cardCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{},"cardCss":{}}}],"type":"top_story","setting":{"tittleCss":{"style":{"color":"#000000","font-size":"16px"}},"subtittleCss":{"style":{"color":"#000000","font-size":"16px"}},"contentCss":{"style":{"color":"#000000","font-size":"16px"}},"readmoreCss":{"style":{"color":"#000000","font-size":"14px","text-transform":"uppercase","border-bottom":"2px solid #000","padding-bottom":"2px","font-family":"mmcbold"}}},isBackgroundOn:false,"backgroundCss":{"style":{"background-color":"none"}},"isDividerOn":false,"dividerCss":{"style":{"background-color":"none"}},"selectedBackColorID":-1,"selectedDividerColorID":-1,"fullBorder":false,"rightBorder":false,"fullBorderCss":{"style":{"border-color":"none"}},"rightBorderCss":{"style":{"border-color":"none"}},"borderCss":{"styleTable":{},"styleTd":{},"styleDivider":{"background-color":"none"},"styleBackground":{"background-color":"none"}},
    "selectedFullBorderColorID":-1,"selectedRightBorderColorID":-1
   },
    {"layout":1,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{},"cardCss":{}}}],"type":"main_story","setting":{"tittleCss":{"style":{"color":"#000000","font-size":"16px"}},"subtittleCss":{"style":{"color":"#000000","font-size":"16px"}},"contentCss":{"style":{"color":"#000000","font-size":"16px"}},"readmoreCss":{"style":{"color":"#000000","font-size":"14px","text-transform":"uppercase","border-bottom":"2px solid #000","padding-bottom":"2px","font-family":"mmcbold"}}},isBackgroundOn:false,"backgroundCss":{"style":{"background-color":"none"}},"isDividerOn":false,"dividerCss":{"style":{"background-color":"none"}},"selectedBackColorID":-1,"selectedDividerColorID":-1,"fullBorder":false,"rightBorder":false,"fullBorderCss":{"style":{"border-color":"none"}},"rightBorderCss":{"style":{"border-color":"none"}},"borderCss":{"styleTable":{},"styleTd":{},"styleDivider":{"background-color":"none"},"styleBackground":{"background-color":"none"}},
    "selectedFullBorderColorID":-1,"selectedRightBorderColorID":-1},
    {"layout":3,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{},"cardCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{},"cardCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{},"cardCss":{}}}],"type":"reminder_item","setting":{"tittleCss":{"style":{"color":"#000000","font-size":"16px"}},"subtittleCss":{"style":{"color":"#000000","font-size":"16px"}},"contentCss":{"style":{"color":"#000000","font-size":"16px"}},"readmoreCss":{"style":{"color":"#000000","font-size":"14px","text-transform":"uppercase","border-bottom":"2px solid #000","padding-bottom":"2px","font-family":"mmcbold"}}},"backgroundCss":{"style":{"background-color":"none"}},isBackgroundOn:false,"isDividerOn":false,"dividerCss":{"style":{"background-color":"none"}},"selectedBackColorID":-1,"selectedDividerColorID":-1,"fullBorder":false,"rightBorder":false,"fullBorderCss":{"style":{"border-color":"none"}},"rightBorderCss":{"style":{"border-color":"none"}},"borderCss":{"styleTable":{},"styleTd":{},"styleDivider":{"background-color":"none"},"styleBackground":{"background-color":"none"}},
    "selectedFullBorderColorID":-1,"selectedRightBorderColorID":-1},
    {"layout":3,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{},"cardCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{},"cardCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{},"cardCss":{}}}],"type":"technical_item","setting":{"tittleCss":{"style":{"color":"#000000","font-size":"16px"}},"subtittleCss":{"style":{"color":"#000000","font-size":"16px"}},"contentCss":{"style":{"color":"#000000","font-size":"16px"}},"readmoreCss":{"style":{"color":"#000000","font-size":"14px","text-transform":"uppercase","border-bottom":"2px solid #000","padding-bottom":"2px","font-family":"mmcbold"}}},isBackgroundOn:false,"backgroundCss":{"style":{"background-color":"none"}},"isDividerOn":false,"dividerCss":{"style":{"background-color":"none"}},"selectedBackColorID":-1,"selectedDividerColorID":-1,"fullBorder":false,"rightBorder":false,"fullBorderCss":{"style":{"border-color":"none"}},"rightBorderCss":{"style":{"border-color":"none"}},"borderCss":{"styleTable":{},"styleTd":{},"styleDivider":{"background-color":"none"},"styleBackground":{"background-color":"none"}},
    "selectedFullBorderColorID":-1,"selectedRightBorderColorID":-1}
  ];

  @ViewChildren(SectionComponent) sect ! : QueryList<SectionComponent>;
  @ViewChild("insideElement",{static: false}) insideElement;
  @ViewChild("sectionElement",{static: false}) sectionElement;
  @ViewChild("backimage",{static: false}) backimage;

  @ViewChild("previmage",{static: false}) previmage;
  @ViewChild("settingico",{static: false}) settingico;

  @ViewChildren("inifont") inifont : QueryList<any>;


  rsetting:any=[];

  sectionSetting:any =[];

  menuSetting:Array<any>=[
    {
      type:'top_story',
      settings:{
        tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        contentCss:{"style":{'color':'#000000','font-size':'16px'}},
        readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},

        selectedTittleColorID:0,
        selectedTittleTextAlignmentID:0,
        selectedTittleFontStyleID:0,
        selectedTittleFontSizeID:0,

        selectedSubTittleTextAlignmentID:0,
        selectedSubTittleFontStyleID:0,
        selectedSubTittleColorID:0,

        selectedContentTextAlignmentID:0,
        selectedContentFontStyleID:0,
        selectedContentColorID:0,

        selectedLinkTextAlignmentID:0,
        selectedLinkFontStyleID:0,
        selectedLinkColorID:0
      }
    },
    {
      type:'main_story',
      settings:{
        tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        contentCss:{"style":{'color':'#000000','font-size':'16px'}},
        readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},

        selectedTittleColorID:0,
        selectedTittleTextAlignmentID:0,
        selectedTittleFontStyleID:0,
        selectedTittleFontSizeID:0,

        selectedSubTittleTextAlignmentID:0,
        selectedSubTittleFontStyleID:0,
        selectedSubTittleColorID:0,

        selectedContentTextAlignmentID:0,
        selectedContentFontStyleID:0,
        selectedContentColorID:0,

        selectedLinkTextAlignmentID:0,
        selectedLinkFontStyleID:0,
        selectedLinkColorID:0
      }
    },
    {
       type:'reminder_item',
       settings:{
        tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        contentCss:{"style":{'color':'#000000','font-size':'16px'}},
        readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},

        selectedTittleColorID:0,
        selectedTittleTextAlignmentID:0,
        selectedTittleFontStyleID:0,
        selectedTittleFontSizeID:0,

        selectedSubTittleTextAlignmentID:0,
        selectedSubTittleFontStyleID:0,
        selectedSubTittleColorID:0,

        selectedContentTextAlignmentID:0,
        selectedContentFontStyleID:0,
        selectedContentColorID:0,

        selectedLinkTextAlignmentID:0,
        selectedLinkFontStyleID:0,
        selectedLinkColorID:0
       }
    },
    {
      type:'technical_item',
      settings:{
        tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        contentCss:{"style":{'color':'#000000','font-size':'16px'}},
        readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},

        selectedTittleColorID:0,
        selectedTittleTextAlignmentID:0,
        selectedTittleFontStyleID:0,
        selectedTittleFontSizeID:0,

        selectedSubTittleTextAlignmentID:0,
        selectedSubTittleFontStyleID:0,
        selectedSubTittleColorID:0,

        selectedContentTextAlignmentID:0,
        selectedContentFontStyleID:0,
        selectedContentColorID:0,

        selectedLinkTextAlignmentID:0,
        selectedLinkFontStyleID:0,
        selectedLinkColorID:0
      }
    },
    {
      type:'dynamic_text_block',
      settings:{
        tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        contentCss:{"style":{'color':'#000000','font-size':'16px'}},
        readmoreCss:{"style":{'display':'none'}},

        selectedTittleColorID:0,
        selectedTittleTextAlignmentID:0,
        selectedTittleFontStyleID:0,
        selectedTittleFontSizeID:0,

        selectedSubTittleTextAlignmentID:0,
        selectedSubTittleFontStyleID:0,
        selectedSubTittleColorID:0,

        selectedContentTextAlignmentID:0,
        selectedContentFontStyleID:0,
        selectedContentColorID:0,

        selectedLinkTextAlignmentID:0,
        selectedLinkFontStyleID:0,
        selectedLinkColorID:0
      }
    }
  ]
  navigation:Array<any>=[]



  onGroupSelect($event:any){

    this.groupError=''

  }





  constructor(private domSanitizer:DomSanitizer,private templateService:TemplateService,private modalService: NgbModal,private calService:CalendarService, private route: ActivatedRoute,homeservice:HomeService,_router: Router,private newsService:NewsletterService , toastr: ToastrService,private renderer: Renderer2, msg:MessageService,private _eref: ElementRef,private articleService:ArticleService){

    super(msg,toastr,homeservice,_router);




    try{



      this.headerDescription =this.hDes;


      this.msg = msg;
      this.toastr = toastr;
      this.homeservice = homeservice;
      this._router =_router;

      this.templateid = +this.route.snapshot.paramMap.get('id');

     

      //console.log(this.newsletterid);


      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);

      this.token = tokenA.token;


      let data={
        token:tokenA.token,
        id:this.templateid
      }



      this.articleService.getTemplateGroup(data).subscribe( (elem)=>{

        if(elem.status =='success'){

           this.templateGroupList = elem.group;

           this.msg.sendMessage({'user':elem.user.name,'notification':elem.notification,'type':'left_menu_link','navigations':elem.navigation});


        }



      });





      if(this.templateid){


            let data={
              token:tokenA.token,
              id:this.templateid,
          
            }


            this.templateService.templateDataById(data).subscribe( (elem)=>{


            //  console.log(elem);

              if(elem.status =='success'){



                this.template_name = elem.template[0].name;

                this.headerDescription = elem.template[0].sections.header;

                this.footerDescription = elem.template[0].sections.footer;

                this.sections = elem.template[0].sections.sectionData.map((section) => {
                  if (section.type === 'dynamic_text_block') {
                    section.elements[0].navObject.id = '999';
                    section.setting.readmoreCss.style = { display: 'none' };
                  }
                  return section;
                });

                this.selectedGroup = this.templateGroupList.filter( (ele) => {  return ele.key == elem.template[0].group ;});





              }else{

                console.log('error');

              }



            });



          }









 }catch(exc){

   _router.navigate(['/login']);

 }



  }



  updateCreateElements(){


    console.log('update function ');


  }


  showCreateElements(){


         this.sections.forEach( (element,i) =>{


                 this.sections[i].elements = this.sections[i].elements.splice(0,element.layout);

         });

         this.sections.map((x,i)=>{
            if(x.isDividerOn==true && x.layout ==1){
              x.borderCss.styleDivider['margin-bottom']= '30px'

            }
         })

        
         if(this.selectedGroup.length==0){

         this.groupError =" Please select group"

         this.toastr.warning('Please select template group !', '', {timeOut: 3000});

         window.scrollTo(0, 0);

         }else{
           
          if(this.templateid > 0){

            let data={
              token:this.token,
              details:
              {
                'page':'template',
                "name":this.template_name,
                "id":this.templateid,
                "group":this.selectedGroup[0].key,
                "sections":{ header:this.headerDescription, footer:this.footerDescription, sectionData:this.sections }
             }
            };
  
  
            this.templateService.createtemplateData(data).subscribe( (elem)=>{
  
  
               if(elem.status =='success'){
  
                 this.toastr.success('Template hasbeen updated successfully', '', {timeOut: 3000});
                 this._router.navigate(['/template']);
  
  
             }else{
  
               this.toastr.success('Template update  failed !', '', {timeOut: 3000});
  
             }
  
  
  
            });
  
             
  
  
  
           } else{
  
  
            let data={
              token:this.token,
              details:
              {
                'page':'template',
              "name":this.template_name,
              "sections":{ header:this.headerDescription, footer:this.footerDescription, sectionData:this.sections }
             }
            };
  
            if(this.selectedGroup[0]){
              data.details['group'] = this.selectedGroup[0].key 
            }
  
  
  
            this.templateService.createtemplateData(data).subscribe( (elem)=>{
  
  
               if(elem.status =='success'){
  
                 this.toastr.success('Template hasbeen created successfully', '', {timeOut: 3000});
  
                 this._router.navigate(['/template']);
  
  
             }else{
  
               this.toastr.success('Template save failed !', '', {timeOut: 3000});
  
             }
  
  
  
            });
  
  
           }

         }


  }



  openShare(){


   this.showMsg =true;


  // console.log(this.sections);

   let is_blank=0;

   let total_element =0;

   this.sections.forEach( (items)=>{


       items.elements.forEach( (items2)=>{

        total_element++;

         if(items2.navObject!=undefined && items2.navObject.id !=undefined){

            is_blank++;




         }

       });

   });




   if(is_blank > 0 && total_element> 0 && (is_blank == total_element )){



   // this.saveImageForSend();




       const modalRef1 = this.modalService.open(NgbdModalBasic,{ windowClass : "invite_popup"});

        modalRef1.componentInstance.month = false;

        modalRef1.componentInstance.year =false;


        modalRef1.componentInstance.newsletterI = this.modified_newsletter;

        modalRef1.componentInstance.finalShare=true;


        modalRef1.componentInstance.passEntry.subscribe((receivedEntry) => {



          modalRef1.close();



          let timeNow= receivedEntry.sdate+' '+receivedEntry.time.hour+':'+receivedEntry.time.minute;




          this.calService.send_invite_now
          ({
          'token':this.token,
          'details':{
                      id:receivedEntry.invite.id,
                      name: receivedEntry.invite.templateName,
                      publish:receivedEntry.invite.publish,
                      number:receivedEntry.invite.templateNumber,
                      send:receivedEntry.invite.invite,
                      fromname: receivedEntry.fromname,
                      fromemail: receivedEntry.fromemail,
                      schedule:timeNow ,
                      sections: receivedEntry.invite.sections ,
                      image: receivedEntry.invite.image

                    },


          }).subscribe( (evt)=>{

               if(evt.status =='success'){

                  this.toastr.success('Newsletter scheduled successfully', '', {timeOut: 3000});


               }else{

                 this.toastr.success('Newsletter scheduled failed', '', {timeOut: 3000});

               }

               });










    });



   } else{

    this.toastr.success('Please Complete the Newsletter !', '', {timeOut: 3000});


   }






  }





  uploadBanner($event){



    this.processFiles($event.target.files);

  }

  setImageBanner(){



    $("#bannerImage").trigger("click");


  }

  processFiles(files){

    for (var i=0, file; file=files[i]; i++) {
        if (file.type.match(/image.*/)) {
            let file = files[i];
            var reader = new FileReader();

            reader.onload = function(e2) {
                // finished reading file data.
                var img:any = document.createElement('img');
                img.src= e2.target.result;
                img.height ='240';
                img.style.width = '100%';
                img.style['object-fit']='cover';

                this.backimage.nativeElement.innerHTML='';

                this.previmage.nativeElement.innerHTML='';

                this.bannerImage =e2.target.result;

                $('.bannerImg').addClass('p-0');

                this.renderer.appendChild(this.backimage.nativeElement, img.cloneNode(true));

                this.renderer.appendChild(this.previmage.nativeElement, img.cloneNode(true));


                try{
                  let res:any = reader.result;
                  let token:any = JSON.parse(atob(localStorage.getItem('token')));
                  var data = new FormData();
                  data.append( 'upload[0][content]',res);
                  data.append( 'upload[0][name]',file.name);

                  let obj={
                    token:token,
                    reqData:data
                  }

                  this.newsService.imageUpload(obj).subscribe( (res) =>{

                    if(res.status=='success'){

                    //  this.bannerImage = this.url+res.files[0].path
                     this.bannerImage = res.files[0].path

                    }else{
                      this._router.navigate(['/login']);
                    }

                  })

                }catch(exec){
                  this._router.navigate(['/login']);
                }




            }.bind(this);

            reader.readAsDataURL(file); // start reading the file data.
        }
    }

  }




  dropv2(e:any){

    e.stopPropagation();
    e.preventDefault();

    this.processFiles(e.dataTransfer.files);


  }

  allowDrop(e:any){

    e.stopPropagation();
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
  }








  drag(ev:any,detail:any,type:string) {



    //ev.dataTransfer.setData("text", JSON.stringify({'classes':ev.target.classList.toString() ,'id':ev.target.id}) );



      if(ev.dataTransfer!=undefined){

        ev.dataTransfer.setData("text",JSON.stringify({'action':'insert','nav_obj':detail,'type':type}));


      }

}



  actionSection(event:any){





    switch(event.action){

     case 'insert_record':


     this.sections[event.evt.pos].elements[event.evt.epos].navObject = event.evt.data.nav_obj;


     this.sect.forEach((div: SectionComponent) =>  {

            if(div.pos == event.evt.pos){

              div.boxes.forEach( (div2: BoxComponent) => {


                    if(div2.belef!=undefined){

                      div2.belef.nativeElement.removeAttribute('style');

                    }


              });


            }

     });



     break;


     case 'swap_record':

              let p = this.sections[event.evt.pos].elements[event.evt.epos];

              this.sections[event.evt.pos].elements[event.evt.epos] = this.sections[event.evt.data.apos].elements[event.evt.data.epos];

              this.sections[event.evt.data.apos].elements[event.evt.data.epos] =p;

     break;


      case 'order':


          if(event.npos >= 0 && event.npos <= this.sections.length -1 ){

            let p = this.sections[event.pos];

            this.sections[event.pos] = this.sections[event.npos];

            this.sections[event.npos] =p;


          }


      break

     case 'update_section':
        this.sections[event.pos]=event.element
       break
    }



  }



  addasection(type:string){


    switch(type){

      case 'top_story':

          this.sections.push({"layout":3,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"top_story",setting:{
            tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            contentCss:{"style":{'color':'#000000','font-size':'16px'}},
            readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
          },isBackgroundOn:false,"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1,"fullBorder":false,"rightBorder":false ,"fullBorderCss":{"style":{"border-color":"none"}},"rightBorderCss":{"style":{"border-color":"none"}},"borderCss":{"styleTable":{},"styleTd":{},"styleDivider":{"background-color":"none"},"styleBackground":{"background-color":"none"}},
          "selectedFullBorderColorID":-1,"selectedRightBorderColorID":-1});


      break;


      case 'main_story':


          this.sections.push({"layout":1,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"main_story",setting:{
            tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            contentCss:{"style":{'color':'#000000','font-size':'16px'}},
            readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
          },isBackgroundOn:false,"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1,"fullBorder":false,"rightBorder":false,"fullBorderCss":{"style":{"border-color":"none"}},"rightBorderCss":{"style":{"border-color":"none"}},"borderCss":{"styleTable":{},"styleTd":{},"styleDivider":{"background-color":"none"},"styleBackground":{"background-color":"none"}},
          "selectedFullBorderColorID":-1,"selectedRightBorderColorID":-1});


      break;


      case 'reminder_item':


          this.sections.push({"layout":3,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"reminder_item",setting:{
            tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            contentCss:{"style":{'color':'#000000','font-size':'16px'}},
            readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
          },isBackgroundOn:false,"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1, "fullBorder":false,"rightBorder":false,"fullBorderCss":{"style":{"border-color":"none"}},"rightBorderCss":{"style":{"border-color":"none"}},"borderCss":{"styleTable":{},"styleTd":{},"styleDivider":{"background-color":"none"},"styleBackground":{"background-color":"none"}},
          "selectedFullBorderColorID":-1,"selectedRightBorderColorID":-1});



      break;


      case 'technical_item':


          this.sections.push({"layout":3,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"technical_item",setting:{
            tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            contentCss:{"style":{'color':'#000000','font-size':'16px'}},
            readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
          },isBackgroundOn:false,"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1, "fullBorder":false,"rightBorder":false,"fullBorderCss":{"style":{"border-color":"none"}},"rightBorderCss":{"style":{"border-color":"none"}},"borderCss":{"styleTable":{},"styleTd":{},"styleDivider":{"background-color":"none"},"styleBackground":{"background-color":"none"}},
          "selectedFullBorderColorID":-1,"selectedRightBorderColorID":-1});

      break;

      case 'dynamic_text_block':

          // The placeholder id marks the slot as filled for the newsletter completeness check.
          this.sections.push({"layout":1,"elements":[{"navObject":{"id":"999","headingCss":{},"descriptionCss":{}}}],"type":"dynamic_text_block",setting:{
            tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            contentCss:{"style":{'color':'#000000','font-size':'16px'}},
            readmoreCss:{"style":{'display':'none'}},
          },isBackgroundOn:false,"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1,"fullBorder":false,"rightBorder":false,"fullBorderCss":{"style":{"border-color":"none"}},"rightBorderCss":{"style":{"border-color":"none"}},"borderCss":{"styleTable":{},"styleTd":{},"styleDivider":{"background-color":"none"},"styleBackground":{"background-color":"none"}},
          "selectedFullBorderColorID":-1,"selectedRightBorderColorID":-1});

      break;



     }




    $('#exampleModal').modal('hide');

  }

  ngOnInit(){

    this.dropdownSettings = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      closeDropDownOnSelection:true


    };


    window.scrollTo(0, 0);

    this.navSettingStyle={
      display:'none'
    }
    this.navSectionStyle={
      display:'none'
    }


  }

  process(srch:string){

    this.srchTxt = srch;
  }

  ngAfterViewInit(){


    $(function(){


      $('#accordion .panel').on('click',function(e){

      });

      var flag=1;

    });


  }


  ngAfterViewChecked(){


    this.sect.forEach((div: SectionComponent) =>  {


       let maxHeight = 0,maxParHeight=0,cardHeight=0

      div.boxes.forEach( (div2: BoxComponent) => {



        this.sections[div2.pos].elements[div2.element_pos].navObject['headingCss']={}
        this.sections[div2.pos].elements[div2.element_pos].navObject['descriptionCss']={}
        this.sections[div2.pos].elements[div2.element_pos].navObject['cardCss']={}

              //  if(div2.telef!=undefined){

              //   if(div2.telef.nativeElement.offsetHeight > maxHeight ){

              //     maxHeight = div2.telef.nativeElement.offsetHeight;
              //   }

              //  }
               if(div2.belef!=undefined){



                if(div2.belef.nativeElement.offsetHeight > maxParHeight ){

                  maxParHeight = div2.belef.nativeElement.offsetHeight;
                }

               }

               if(div2.celef!=undefined){

                if(div2.celef.nativeElement.offsetHeight > cardHeight ){

                  cardHeight = div2.celef.nativeElement.offsetHeight;
                }

               }

      });

      div.boxes.forEach( (div2: BoxComponent) => {

              // if(div2.telef!=undefined){

              //     this.renderer.setStyle(div2.telef.nativeElement, "height", maxHeight+'px');
              //     this.sections[div2.pos].elements[div2.element_pos].navObject.headingCss['fontSize']=maxHeight+'px'
              // }



              if(div2.belef!=undefined){



                this.renderer.setStyle(div2.belef.nativeElement, "height", maxParHeight+'px');
                this.sections[div2.pos].elements[div2.element_pos].navObject.descriptionCss['fontSize']=maxParHeight+'px'

             }

             if(div2.celef!=undefined){
              this.sections[div2.pos].elements[div2.element_pos].navObject.cardCss['fontSize']=cardHeight+'px'
             }

      });

   });



  }

  ngOnChanges(changes:SimpleChanges){


  }

  ngOnDestroy(){

  }






  deleteSection(position: number) {


    this.sectionRemoveId =position;



    $('#remove-modal').modal('show');


    //  this.removeSettingDialog ={
    //    display:'block'
    //  }





   }


   hideremoveSection(){



    $('#remove-modal').modal('hide');
   }

     removeSection(){


      $('#remove-modal').modal('hide');

      this.sections.splice(this.sectionRemoveId,1);

   }



 closeModal(){
  $("#preview-modal").modal('hide')
 }

 setMyStyles(val) {

  //   let style={
  //     height:'0px'
  //   }

  //  if(val.navObject.descriptionCss!=undefined && val.navObject.descriptionCss.fontSize!=undefined){

  //    style={
  //     height:val.navObject.descriptionCss.fontSize
  //   }

  //  }
  //  return style
 }


 showSettingLeft($evt){

 

  this.navSetting($evt.evt,$evt.index,$evt.tittle,$evt.settingico);

 }


 navSetting(evt,index,tittle,settingico){

  if(this.navSettingIndex ==index){

    this.navSettingStyle={
      display:'none'
    }

    this.navSettingIndex =-1;

  }else{


  this.navSettingIndex=index
  this.navSettingHeader=tittle

  let lft = settingico.left -240 +42;


  let rht = settingico.top -20;

  if(index ==2){

    rht = rht - 120;

  }

  if(index ==3){

    rht = rht - 150;

  }





  this.navSettingStyle={

    display:'block',
    'top':rht+'px',
    'left':lft+'px',
     position:'fixed'
  }
  }
  if(this.navSettingIndex>-1){

    this.rsetting = this.navigation.filter( (item,k) => { return  k == this.navSettingIndex});

   }else{

    this.rsetting =[];
   }

 evt.stopPropagation();

}







onClick(event) {



  if(this.insideElement !=undefined){


    const clickedInside = this.insideElement.nativeElement.contains(event.target);

        if (!clickedInside) {

          this.navSettingStyle={

                display:'none'
          }

          this.navSettingIndex =-1;
        }


      }

      if(this.sectionElement !=undefined ){

        const clickedInside1 = this.sectionElement.nativeElement.contains(event.target);

        if (!clickedInside1) {

          this.navSectionStyle={

                display:'none'
          }

          this.navSectionIndex =-1;
        }



  }





}

onColorChange(value,id){
  if( this.navigation[this.navSettingIndex].setting.selectedTittleColorID==id){
    this.navigation[this.navSettingIndex].setting.selectedTittleColorID=0
    this.navigation[this.navSettingIndex].setting.tittleCss.style.color='#000000'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{
    this.navigation[this.navSettingIndex].setting.selectedTittleColorID=id
    this.navigation[this.navSettingIndex].setting.tittleCss.style.color=value
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }

}

popupSection(event){



  let fixedBoxOffsetTop =0;

  let fixedBoxOffsetLeft =0;


  this.sect.forEach((div: SectionComponent) =>  {




    if(div.pos == event.s_index){



      fixedBoxOffsetTop = div.set2.nativeElement.getBoundingClientRect().top;

     
      fixedBoxOffsetLeft = div.set2.nativeElement.getBoundingClientRect().left - 268 ;



    }



  });

  this.currentSectionIndex=event.s_index

  if(this.navSectionIndex ==event.s_index){

    this.navSectionStyle={
      display:'none'
    }

    this.navSectionIndex =-1;

  }else{


   // console.log(event.evt.clientY);




  this.navSectionIndex=event.s_index
  this.navSectionStyle={
    display:'block',
    'top':fixedBoxOffsetTop+'px',

    'left': fixedBoxOffsetLeft+'px',
     'position':'fixed',


  }


  }

  if(this.currentSectionIndex>-1){

    this.sectionSetting = this.sections.filter( (item,k) => { return  k == this.currentSectionIndex});

   }else{

    this.sectionSetting =[];
   }

  event.evt.stopPropagation();


}

onAlignmentChange(value,id){

  this.navigation[this.navSettingIndex].setting.selectedTittleTextAlignmentID=id
  this.navigation[this.navSettingIndex].setting.tittleCss.style['text-align']=value
  this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

}

onFontStyleChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedTittleFontStyleID==id){
    this.navigation[this.navSettingIndex].setting.selectedTittleFontStyleID=0
    this.navigation[this.navSettingIndex].setting.tittleCss.style['text-decoration']='none'
    this.navigation[this.navSettingIndex].setting.tittleCss.style['font-weight']='normal'
    this.navigation[this.navSettingIndex].setting.tittleCss.style['font-style']='normal'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{

    this.navigation[this.navSettingIndex].setting.selectedTittleFontStyleID=id

    if(value==='underline'){
      this.navigation[this.navSettingIndex].setting.tittleCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-style']='normal'
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }else if(value==='bold'){
      this.navigation[this.navSettingIndex].setting.tittleCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-style']='normal'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-weight']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
    else{
      this.navigation[this.navSettingIndex].setting.tittleCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-style']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
  }



}

onsubTittleAlignmentChange(value,id){

  this.navigation[this.navSettingIndex].setting.selectedSubTittleTextAlignmentID=id
  this.navigation[this.navSettingIndex].setting.subtittleCss.style['text-align']=value
  this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

}

onSubTittleFontStyleChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedSubTittleFontStyleID==id){

    this.navigation[this.navSettingIndex].setting.selectedSubTittleFontStyleID=0
    this.navigation[this.navSettingIndex].setting.subtittleCss.style['text-decoration']='none'
    this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-weight']='normal'
    this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-style']='normal'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{
    this.navigation[this.navSettingIndex].setting.selectedSubTittleFontStyleID=id

    if(value==='underline'){
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-style']='normal'
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }else if(value==='bold'){
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-style']='normal'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-weight']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
    else{
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-style']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
  }

 }

 onSubTittleColorChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedSubTittleColorID==id){
    this.navigation[this.navSettingIndex].setting.selectedSubTittleColorID=0
    this.navigation[this.navSettingIndex].setting.subtittleCss.style.color='#000000'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{
    this.navigation[this.navSettingIndex].setting.selectedSubTittleColorID=id
    this.navigation[this.navSettingIndex].setting.subtittleCss.style.color=value
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }


 }

onContentAlignmentChange(value,id){

  this.navigation[this.navSettingIndex].setting.selectedContentTextAlignmentID=id
  this.navigation[this.navSettingIndex].setting.contentCss.style['text-align']=value
  this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);


}

onContentFontStyleChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedContentFontStyleID==id){

    this.navigation[this.navSettingIndex].setting.selectedContentFontStyleID=0
    this.navigation[this.navSettingIndex].setting.contentCss.style['text-decoration']='none'
    this.navigation[this.navSettingIndex].setting.contentCss.style['font-weight']='normal'
    this.navigation[this.navSettingIndex].setting.contentCss.style['font-style']='normal'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{

    this.navigation[this.navSettingIndex].setting.selectedContentFontStyleID=id

    if(value==='underline'){
      this.navigation[this.navSettingIndex].setting.contentCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-style']='normal'
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }else if(value==='bold'){
      this.navigation[this.navSettingIndex].setting.contentCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-style']='normal'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-weight']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
    else{
      this.navigation[this.navSettingIndex].setting.contentCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-style']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
  }

}

onContentColorChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedContentColorID==id){
    this.navigation[this.navSettingIndex].setting.selectedContentColorID=0
    this.navigation[this.navSettingIndex].setting.contentCss.style.color='#000000'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{
    this.navigation[this.navSettingIndex].setting.selectedContentColorID=id
    this.navigation[this.navSettingIndex].setting.contentCss.style.color=value
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }


 }

 onLinkAlignmentChange(value,id){

   this.navigation[this.navSettingIndex].setting.selectedLinkTextAlignmentID=id
   this.navigation[this.navSettingIndex].setting.readmoreCss.style['text-align']=value
   this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

 }
 onLinkFontStyleChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedLinkFontStyleID==id){

    this.navigation[this.navSettingIndex].setting.selectedLinkFontStyleID=0
    this.navigation[this.navSettingIndex].setting.readmoreCss.style['text-decoration']='none'
    this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-weight']='normal'
    this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-style']='normal'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{

    this.navigation[this.navSettingIndex].setting.selectedLinkFontStyleID=id

    if(value==='underline'){
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-style']='normal'
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }else if(value==='bold'){
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-style']='normal'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-weight']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
    else{
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-style']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
  }

}

onLinkColorChange(value,id){
  if(this.navigation[this.navSettingIndex].setting.selectedLinkColorID==id){
    this.navigation[this.navSettingIndex].setting.selectedLinkColorID=0
    this.navigation[this.navSettingIndex].setting.readmoreCss.style.color='#000000'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
  }else{
    this.navigation[this.navSettingIndex].setting.selectedLinkColorID=id
    this.navigation[this.navSettingIndex].setting.readmoreCss.style.color=value
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
  }

 }

 fontSizeChange(event: any, type: string) {

  this.inifont.forEach((ini) => {

      if (ini.nativeElement.classList.contains(type)) {

          ini.nativeElement.value = event.target.value;

      }
  });

  switch (type) {

      case 'title_change':

          this.navigation[this.navSettingIndex].setting.tittleCss.style['font-size'] = event.target.value + 'px';
          this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
          break;

      case 'subtitle_change':

          this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-size'] = event.target.value + 'px';
          this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

          break;

      case 'content_change':

        this.navigation[this.navSettingIndex].setting.contentCss.style['font-size'] = event.target.value + 'px';
        this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

        break;

    case 'link_change':

      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-size'] = event.target.value + 'px';
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

      break;

  }

}

sendRecord(setting:any, type:any){

   this.msg.sendMessage({'action':'sendNavSettings','records':setting,'type':type});

}

dividerVisibility(evt){

  this.sections[this.currentSectionIndex].isDividerOn=evt.target.checked

}

backgroundVisibility(evt){

  this.sections[this.currentSectionIndex].isBackgroundOn=evt.target.checked

 

}

fullBorderVisibility(evt){

  this.sections[this.currentSectionIndex].fullBorder=evt.target.checked;
  this.sections[this.currentSectionIndex].rightBorder=false;
  this.sections[this.currentSectionIndex].borderCss.styleTable['border'] ="1px solid"
  this.sections[this.currentSectionIndex].borderCss.styleTd['padding'] ="5px"
  

}

rightBorderVisibility(evt){

  this.sections[this.currentSectionIndex].rightBorder=evt.target.checked;
  this.sections[this.currentSectionIndex].fullBorder=false;

  this.sections[this.currentSectionIndex].borderCss.styleTable['border-right'] ="2px solid"
  this.sections[this.currentSectionIndex].borderCss.styleTable['width'] ="280px"
  this.sections[this.currentSectionIndex].borderCss.styleTable['margin-right'] ="0"
  this.sections[this.currentSectionIndex].borderCss.styleTd['padding-left'] ="15px"
  this.sections[this.currentSectionIndex].borderCss.styleTd['padding-right'] ="15px"
  this.sections[this.currentSectionIndex].borderCss.styleTd['margin-right'] = "0"
 

}

onRightBorderColorChange(value,id){

  if( this.sections[this.currentSectionIndex].selectedRightBorderColorID==id){
    this.sections[this.currentSectionIndex].selectedRightBorderColorID=-1
    this.sections[this.currentSectionIndex].rightBorderCss.style['border-color']='none'
    this.sections[this.currentSectionIndex].borderCss.styleTable['border-color'] = '#dddee0'

  }else{
    this.sections[this.currentSectionIndex].selectedRightBorderColorID=id
    this.sections[this.currentSectionIndex].rightBorderCss.style['border-color']=value
    this.sections[this.currentSectionIndex].borderCss.styleTable['border-color'] = value

  }

}

onDividerColorChange(value,id){

  if( this.sections[this.currentSectionIndex].selectedDividerColorID==id){
    this.sections[this.currentSectionIndex].selectedDividerColorID=-1
    this.sections[this.currentSectionIndex].dividerCss.style['background-color']='#ffffff'
    this.sections[this.currentSectionIndex].borderCss.styleDivider['background-color'] ="#ffffff"
  }else{
   
    this.sections[this.currentSectionIndex].selectedDividerColorID=id
    this.sections[this.currentSectionIndex].dividerCss.style['background-color']=value

    this.sections[this.currentSectionIndex].borderCss.styleDivider['background-color'] =value
  
  }
 

}



onSecBakColorChange(value,id){

  if(this.sections[this.currentSectionIndex].selectedBackColorID==id){
    this.sections[this.currentSectionIndex].selectedBackColorID=-1
    this.sections[this.currentSectionIndex].backgroundCss.style['background-color']='#ffffff'
    this.sections[this.currentSectionIndex].borderCss.styleBackground['background-color'] = '#ffffff'
    this.sections[this.currentSectionIndex].borderCss.styleBackground['padding-top'] = '15px'
    this.sections[this.currentSectionIndex].borderCss.styleBackground['padding-bottom'] = '15px'

  }else{
    
    this.sections[this.currentSectionIndex].selectedBackColorID=id
    this.sections[this.currentSectionIndex].backgroundCss.style['background-color']=value
    this.sections[this.currentSectionIndex].borderCss.styleBackground['background-color'] = value
    this.sections[this.currentSectionIndex].borderCss.styleBackground['padding-top'] = '15px'
    this.sections[this.currentSectionIndex].borderCss.styleBackground['padding-bottom'] = '15px'
    
  }

}


onFullBorderColorChange(value,id){

  if( this.sections[this.currentSectionIndex].selectedFullBorderColorID==id){
    this.sections[this.currentSectionIndex].selectedFullBorderColorID=-1
    this.sections[this.currentSectionIndex].fullBorderCss.style['border-color']='#dddee0'
    this.sections[this.currentSectionIndex].borderCss.styleTable['border-color'] = '#dddee0'


  }else{
    this.sections[this.currentSectionIndex].selectedFullBorderColorID=id
    this.sections[this.currentSectionIndex].fullBorderCss.style['border-color']=value
    this.sections[this.currentSectionIndex].borderCss.styleTable['border-color'] = value


  }

}





saveImageForSend(){



  if(this.templateName!=undefined && this.bannerImage!=undefined){

    //document.getElementById('capture').style.display='block';

    $('#render-snapshot').html($('#preview-modal').html());



    html2canvas(document.getElementById("render-snapshot")).then(canvas => {

      var width = document.getElementById('render-snapshot').offsetWidth;
      var height = document.getElementById('render-snapshot').offsetHeight;

      var tempcanvas=document.createElement('canvas');
      tempcanvas.width=width;
      tempcanvas.height=height;
      var context=tempcanvas.getContext('2d');
      context.drawImage(canvas, 0, 0, width, height);
      var link=document.createElement("a");
      link.href=tempcanvas.toDataURL('image/jpg');   //function blocks CORS

     // link.download = this.templateName+'.jpg';
    //  link.click();

      try{
        let res:any = link.href;
        let token:any = JSON.parse(atob(localStorage.getItem('token')));
        var data = new FormData();
        data.append( 'upload[0][content]',res);
        data.append( 'upload[0][name]',this.templateName);

        let obj={
          token:token,
          reqData:data
        }

        this.newsService.imageUpload(obj).subscribe( (res) =>{


          if(res.status=='success'){

          // document.getElementById('capture').style.display='none';

          //  this.snapImage = this.url+res.files[0].path;

          $('#render-snapshot').html('');

           this.snapImage = res.files[0].path;



           this.finalJson.sections.bannerImage=this.bannerImage;
           this.finalJson.sections.sectionData=this.sections;
           this.finalJson.sections.menuSetting=this.menuSetting;
           this.finalJson.image = this.snapImage;






          }

        })

      }catch(exec){
        this._router.navigate(['/login']);
      }

   });




  }else{
   console.log('template name and banner image can not be empty')
  }




}


cropCanvas(sourceCanvas,left,top,width,height){
  let destCanvas = document.createElement('canvas');
  destCanvas.width = width;
  destCanvas.height = height;
  destCanvas.getContext("2d").drawImage(
      sourceCanvas,
      left,top,width,height,  // source rect with content to crop
      0,0,width,height);      // newCanvas, same size as source rect
  return destCanvas;
}


onCheckChange(event){

  if(this.checkedval==true){
    this.finalJson['private']=1
   }else{
    this.finalJson['private']=0
   }

}

saveJson(e:Event){


  //e.preventDefault();

  if(this.templateName!=undefined && this.bannerImage!=undefined){

    //document.getElementById('capture').style.display='block';

    //console.log($('#preview-modal').html());

    //$('#render-snapshot').html($('.right-newsletterarea').html());

     window.scrollTo(0,0);

     $('#hide_below_snapshot').hide();

    html2canvas(document.getElementById('ss2'),{ allowTaint: true, useCORS: true
    }).then(canvas => {


        var tempcanvas=document.createElement('canvas');

        tempcanvas.width=canvas.width ;
        tempcanvas.height=canvas.height;
        var context=tempcanvas.getContext('2d');





       context.drawImage(canvas, 0, 0, tempcanvas.width,tempcanvas.height );


      var link=document.createElement("a");
      link.href=tempcanvas.toDataURL('image/png');   //function blocks CORS

      link.download = this.templateName+'.png';
      //link.click();


      $('#hide_below_snapshot').show();



      try{
        let res:any = link.href;
        let token:any = JSON.parse(atob(localStorage.getItem('token')));
        var data = new FormData();
        data.append( 'upload[0][content]',res);
        data.append( 'upload[0][name]',this.templateName);

        let obj={
          token:token,
          reqData:data
        }

        this.newsService.imageUpload(obj).subscribe( (res) =>{
         // console.log('ffffkkkkkkkk',res)

          if(res.status=='success'){

          // document.getElementById('capture').style.display='none';

          //  this.snapImage = this.url+res.files[0].path;

          //$('#render-snapshot').html('');

           this.snapImage = res.files[0].path;
           this.finalJson.templateName = this.templateName;
           this.finalJson.image = this.snapImage;
           this.finalJson.sections.bannerImage=this.bannerImage;
           this.finalJson.sections.sectionData=this.sections;
           this.finalJson.sections.menuSetting=this.menuSetting;

           this.saveTemplate();

          }else{
            this._router.navigate(['/login']);
          }

        })

      }catch(exec){
        this._router.navigate(['/login']);
      }




   });



  }else{
   console.log('template name and banner image can not be empty')
  }



}

saveTemplate(){

  let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

  if(!tokenA) throw 'Error in parse';

  if(!JSON.parse(tokenA)) throw 'Error in json parse';

  tokenA = JSON.parse(tokenA);

   let reqdata={
    token:tokenA.token,
    reqData:this.finalJson
   }
  this.newsService.newsletterData(reqdata).subscribe( (res) =>{

    //console.log('res',res)

    if(res.status=='success'){

      this.finalJson.id= res.id;

      if(this.showMsg){

        this.toastr.success('Newsletter is saved successfully !', '', {timeOut: 3000});

      }


    }else{

      if(this.showMsg){

        this.toastr.success('Newsletter cant saved  !', '', {timeOut: 3000});

      }



    }

  })

}

}
